import { SxProps } from '@mui/material';

export const OrderDetailsSx: SxProps = {
  display: 'inlineFlex',
  justifyContent: 'space-between',
  ml: '-16px',
  width: 'calc(100% + 16px)',
};

export const HeaderSx = {
  mb: '12px',
  fontWeight: '600',
  fontSize: '14px',
  color: '131414',
};
